import { KendoChartFormComponent } from './form/kendochart-form.component';

export const CHARTS_DECLARATIONS: any[] = [KendoChartFormComponent];
